import Heading from '@commons/Heading/Heading';

/**
 * Blurb description component.
 */
export default function BlurbDescription({ children, className = '' }) {
  if (!children) return null;

  return <div className={`Blurb__description ${className}`}>{children}</div>;
}
